import { patch } from "../../state/store.js";
import { connectSyncSocket } from "../sync.js";
import { persistAuth } from "./auth-state.js";
import { hydrateFromServer } from "./hydrate.js";
import { apiFetch } from "./request.js";

export async function login(email) {
  patch({ loginError: "", loginPending: true });
  try {
    const data = await apiFetch("/auth/login", { method: "POST", body: JSON.stringify({ email }) });
    const auth = { email: data.user.email, token: data.token, user: data.user };
    persistAuth(auth);
    patch({
      userEmail: auth.email,
      authToken: auth.token,
      user: auth.user,
      loginError: "",
      loginPending: false,
      accounts: [],
      accountFilter: [],
      chats: [],
      chatMessages: {},
      activeChatJid: "",
      whatsappSession: null,
      leads: [],
      funnels: [],
      activeFunnelId: "",
    });
    try {
      await hydrateFromServer();
      connectSyncSocket();
    } catch (err) {
      console.warn("[wcrm] post-login hydrate failed", err);
    }
    return data;
  } catch (err) {
    patch({ loginError: err?.message || "Falha ao entrar", loginPending: false });
    throw err;
  }
}
